const PUB_SUB_EVENTS = window.PUB_SUB_EVENTS || Object.freeze({
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
});

window.PUB_SUB_EVENTS = PUB_SUB_EVENTS;

let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    const promises = subscribers[eventName]
      .map((callback) => Promise.resolve()
        .then(() => callback(data))
        .catch((error) => {
          // A non-critical listener (for example quantity-rule refresh) must
          // never cancel add-to-cart rendering or prevent the drawer opening.
          console.error(`Subscriber for ${eventName} failed`, error);
          return undefined;
        }))
    return Promise.all(promises);
  } else {
    return Promise.resolve()
  }
}

window.subscribe = subscribe;
window.publish = publish;
